export class QuoteTabNameModel {
    accepted = 'ACCEPTED';
    archived = 'ARCHIVED';
    active = 'ACTIVE';
}
